<script lang="ts">
  import { translation } from '$lib/locale/locale';
  import type { Tag } from '$lib/models/tag';
  import { AssetType } from '$lib/utils/asset';

  const { langHref } = translation();

  export let tags: Tag[];
  export let title = '';
  export let assetType: AssetType = AssetType.Track;

  export let color = '#647281';
  export let borderColor = '#dee0e3';
  export let hoverBackground = 'var(--cultured)';

  function getLink(tag: Tag) {
    if (assetType === AssetType.Track) {
      return langHref('/royalty-free-music/?tagId=' + tag.id);
    } else if (assetType === AssetType.SFX) {
      return langHref('/sound-effects/?tagId=' + tag.id);
    } else if (assetType === AssetType.Intro) {
      return langHref('/intros/?tagId=' + tag.id);
    }
    return '';
  }
</script>

{#if title}
  <h2 class="title">{title}</h2>
{/if}
<div class="d-flex flex-wrap">
  {#each tags as tag (tag.id)}
    <a
      class="tag"
      style="
            border: 1px solid {borderColor}; 
            color: {color}; 
            --tag-hover-background: {hoverBackground};
            "
      href={getLink(tag)}>{tag.name}</a
    >
  {/each}
</div>

<style>
  .title {
    font-size: var(--lg-font-size);
    font-weight: var(--medium-font-weight);
    margin-bottom: 24px;
  }
  .tag {
    padding: 4px 12px;
    color: var(--text-invert-secondary);
    border-radius: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    text-transform: capitalize;
    font-size: var(--base-font-size);
    font-weight: var(--normal-font-weight);
  }

  .tag:hover {
    border-radius: 100px;
    background: var(--tag-hover-background);
    text-decoration: none;
    cursor: pointer;
  }

  @media (max-width: 900px) {
    .tag {
      font-size: var(--xs-font-size);
    }
  }
</style>
